import { Component, Input, DoCheck, OnInit, OnDestroy } from '@angular/core';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { OverlayContainer } from '@angular/cdk/overlay';
import { UntypedFormControl } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { forkJoin, Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil, timeout } from 'rxjs/operators';

// import { TWADialogsModule } from 'twa-md2-dialogs';
import { TwaMd2NotificationsService } from './_components/twa-md2-notifications/twa-md2-notifications.service';

import { ServerConn } from './serverConn.service';
import { DashboardService } from './_services/dashboard.service';
import { AnimalsService } from './_services/animals.service';
import { AuthenticationService } from './_services/authentication.service';
import { WorksService } from './_services/works.service';
import { LibrosService } from './_services/libros.service';
import { CEAService } from './_services/cea.service';
import { CriasService } from './_services/crias.service';
import { WorksPendingService } from './_services/works-pending.service';
import { AppService } from './_services/app.service';
import { AccountService } from './_services/account.service';
import { TWADialogsService } from './_services/twa-dialogs.service';
import { GtagService } from './_directives/gtag/gtag.service';
import { ServerMessagesService } from './_services/server-messages.service';
import { BugsReportsServiceService } from './_services/bugs-reports-service.service';
import { UiService } from './_services/ui.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [ServerConn],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'SIRA Grupos';
    appTitle = 'SIRA Grupos';
    myData: Array<any>;
    response: any;
    logged = false;
    sssn: string;
    ceas: any[] = [];
    ceasWithNames: any[] = [];
    filteredCeas: Observable<string[]>;
    selectedCEA = '';
    selectedCEAObj: any = {};
    sideNavOpened = false;
    themeClass = localStorage.getItem('themeClass') || 'light';
    themeButtonText = 'Dark Theme';

    ceaControl = new UntypedFormControl();
    user: any = false;

    private unsubscribe = new Subject<void>();
    private timeoutSideNav: any = false;

    get isUserLoggedIn(): boolean {
        return (this.auth.authenticated || !!localStorage.getItem('api_key')) && !this.router.url.includes('/login');
    }

    get isAiEnabled(): boolean {
        return this.accountSvc.isAiEnabled || !!(this.user && (this.user.ai_enabled == 1 || this.user.ai_enabled === true || this.user.ai_enabled === '1'));
    }

    constructor(
            private overlayContainer: OverlayContainer,
            private server: ServerConn,
            private router: Router,
            private route: ActivatedRoute,
            private iconRegistry: MatIconRegistry,
            private sanitizer: DomSanitizer,
            public auth: AuthenticationService,
            public dashboardData: DashboardService,
            public ceaSvc: CEAService,
            public criasSvc: CriasService,
            public pendingSvc: WorksPendingService,
            public animalsData: AnimalsService,
            public worksData: WorksService,
            public appService: AppService,
            public accountSvc: AccountService,
            public booksData: LibrosService,
            private gtag: GtagService,
            public notifsSvc: TwaMd2NotificationsService,
            public serverMsgs: ServerMessagesService,
            // private dialogsSvc: TWADialogsModule,
            private dialogsSvc: TWADialogsService,
            public bugsReortsSvc: BugsReportsServiceService,
            public uiSvc: UiService
    ) {

      this.iconRegistry.addSvgIcon(
          'pin',
          sanitizer.bypassSecurityTrustResourceUrl('assets/icons/pin.svg'));
      this.iconRegistry.addSvgIcon(
          'milk-bottle',
          sanitizer.bypassSecurityTrustResourceUrl('assets/icons/milk-bottle.svg'));
      this.iconRegistry.addSvgIcon(
              'female',
              sanitizer.bypassSecurityTrustResourceUrl('assets/icons/female.svg'));
      this.iconRegistry.addSvgIcon(
              'male',
              sanitizer.bypassSecurityTrustResourceUrl('assets/icons/male.svg'));
      this.iconRegistry.addSvgIcon(
              'crias',
              sanitizer.bypassSecurityTrustResourceUrl('assets/icons/crias.svg'));

      if (localStorage.getItem('sideNavOpened')) {
          this.sideNavOpened = (localStorage.getItem('sideNavOpened') > '') ? true : false;
      }

      this.server.get('aux-data/logos').subscribe((res: any) => {
        console.log('🚀 ~ file: login.component.ts:73 ~ LoginComponent ~ this.server.get ~ res:', res);
        this.appService.logo = this.server.serverUrl.substring(0, this.server.serverUrl.length - 1) + res.data.logo;
        this.appService.logo_dark = this.server.serverUrl.substring(0, this.server.serverUrl.length - 1) + res.data.logo_dark;
        this.appService.logo_ministerio = this.server.serverUrl.substring(0, this.server.serverUrl.length - 1) + res.data.logo_ministerio;
      });

      this.selectedCEA = localStorage.getItem('selectedCEA');
      this.ceaControl.setValue(this.selectedCEA);
      if (this.server.user.level >= 7 && this.selectedCEA > '') {
        this.selectedCEAObj = this.ceasWithNames.filter((val: any) => val.cea === this.selectedCEA)[0];
        this.setCEA();
      }

      // const sources = [
      //   this.accountSvc.get(),
      //   this.dashboardData.getPartners(),
      //   this.accountSvc.getProducts(),
      // ];

      // forkJoin(sources)
      //   .pipe(
      //     map(([resAccount, resDashboard, resProducts]) => {
      //       return {
      //         account: resAccount,
      //         dashboard: resDashboard,
      //         products: resProducts,
      //       }
      //     })
      //   ).subscribe((res: any) => {
      //     /**
      //      * res.account
      //      */
      //     this.user = res.account.user;
      //     console.log('🚀 ~ file: app.component.ts:102 ~ AppComponent ~ this.accountSvc.get ~ res.account:', res.account);
      //     if (res.account.logo) {
      //       this.appService.logo = (this.server.serverUrl.substring(0, this.server.serverUrl.length - 1) + res.account.logo);
      //       this.appService.logo_dark = (this.server.serverUrl.substring(0, this.server.serverUrl.length - 1) + res.account.logo_dark);
      //     }
      //     if (res.account.logo_ministerio) {
      //       this.appService.logo_ministerio = (this.server.serverUrl.substring(0, this.server.serverUrl.length - 1) + res.account.logo_ministerio);
      //     }
      //     // console.log('🚀 ~ AppComponent ~ ).subscribe ~ res.products:', res.products);
      //     // this.accountSvc.getProducts().subscribe((respProducts) => {
      //     //     console.log(respProducts);
      //     // });
      //     /**
      //      * res.dashbooard
      //      */
      //     let i: number,
      //         i2: number,
      //         l2: number,
      //         tmpceas: any[];
      //     const l = res.dashboard.length;
      //     if (typeof res.dashboard.ceas !== 'undefined') {
      //       tmpceas = res.dashboard.ceas.replace(' ', '').split(',');
      //       for (i2 = 0, l2 = tmpceas.length; i2 < l2; i2++) {
      //           this.ceas.push(tmpceas[i2]);
      //           this.ceasWithNames.push({
      //             cea: tmpceas[i2],
      //             name: res.dashboard.ceas[i].ganadero
      //         });
      //       }
      //     } else {
      //       for (i = 0; i < l; i++) {
      //         if (typeof res.dashboard[i].ceas !== 'undefined' && res.dashboard[i].ceas !== null) {
      //           tmpceas = res.dashboard[i].ceas.replace(' ', '').split(',');
      //           for (i2 = 0, l2 = tmpceas.length; i2 < l2; i2++) {
      //             this.ceas.push(tmpceas[i2]);
      //             this.ceasWithNames.push({
      //               cea: tmpceas[i2],
      //               name: res.dashboard[i].ganadero
      //             });
      //           }
      //         }
      //       }
      //     }

      //   });

        this.accountSvc.get().subscribe((resp) => {
          this.user = resp.user;
          console.log('🚀 ~ file: app.component.ts:102 ~ AppComponent ~ this.accountSvc.get ~ resp:', resp);
          if (resp.logo) {
            this.appService.logo = (this.server.serverUrl.substring(0, this.server.serverUrl.length - 1) + resp.logo);
            this.appService.logo_dark = (this.server.serverUrl.substring(0, this.server.serverUrl.length - 1) + resp.logo_dark);
          }
          if (resp.logo_ministerio) {
            this.appService.logo_ministerio = (this.server.serverUrl.substring(0, this.server.serverUrl.length - 1) + resp.logo_ministerio);
          }
          this.accountSvc.getProducts().subscribe((respProducts) => {
              console.log(respProducts);
          });
        });

        this.dashboardData.getPartners().subscribe((response: any) => {
            console.log('🚀 ~ file: app.component.ts ~ line 112 ~ AppComponent ~ this.dashboardData.getPartners ~ response', response);
            let i: number,
                i2: number,
                l2: number,
                tmpceas: any[];
            const l = response.length;
            if (typeof response.ceas !== 'undefined') {
                tmpceas = response.ceas.replace(' ', '').split(',');
                for (i2 = 0, l2 = tmpceas.length; i2 < l2; i2++) {
                    this.ceas.push(tmpceas[i2]);
                    this.ceasWithNames.push({
                      cea: tmpceas[i2],
                      name: response.ceas[i].ganadero
                  });
      }
            } else {
                for (i = 0; i < l; i++) {
                    if (typeof response[i].ceas !== 'undefined' && response[i].ceas !== null) {
                        tmpceas = response[i].ceas.replace(' ', '').split(',');
                        for (i2 = 0, l2 = tmpceas.length; i2 < l2; i2++) {
                            this.ceas.push(tmpceas[i2]);
                            this.ceasWithNames.push({
                                cea: tmpceas[i2],
                                name: response[i].ganadero
                            });
                        }
                    }
                }
            }
            // if (this.server.user.level >= 7 && this.selectedCEA > '') {
            //   this.selectedCEAObj = this.ceasWithNames.filter((val: any) => val.cea === this.selectedCEA)[0];
            //   this.setCEA();
            // }
        });

    }

    ngOnInit() {
        this.filteredCeas = this.ceaControl.valueChanges
            .pipe(
                startWith(''),
                map(value => this._filter(value))
        );
        this.setTheme(this.themeClass);
    }

    ngOnDestroy() {
      this.unsubscribe.next();
      this.unsubscribe.complete();
    }

    private _filter(value: string): string[] {
      const filterValue = value.toLowerCase();

      // console.log('🚀 ~ file: app.component.ts ~ line 163 ~ AppComponent ~ results ~ this.ceasWithNames', this.ceasWithNames);
      const results = this.ceasWithNames.filter((cea: any) => {
        return cea.cea.toLowerCase().includes(filterValue) || cea.name.toLowerCase().includes(filterValue);
      }).map(v => v.cea);
      // console.log('🚀 ~ file: app.component.ts ~ line 165 ~ AppComponent ~ results ~ results', results);

      return results;

      // return this.ceas.filter(option => option.toLowerCase().includes(filterValue));
    }

    accountHasModule(module) {
      // console.log('🚀 ~ file: app.component.ts ~ line 158 ~ AppComponent ~ accountHasModule ~ this.accountSvc.products', this.accountSvc.products);
        return this.accountSvc.products &&
                this.accountSvc.products.filter(prod => prod.id === module).length > 0;
      //   return this.accountSvc.data &&
      //          this.accountSvc.data.products &&
      //          this.accountSvc.data.products.filter(prod => prod.id === module);
    }

    toggleSideNav(): void {

      if (this.timeoutSideNav) {
        clearTimeout(this.timeoutSideNav);
      }

      this.sideNavOpened = !this.sideNavOpened;
      localStorage.setItem('sideNavOpened', this.sideNavOpened ? 'true' : '');
      if (this.sideNavOpened) {
        this.timeoutSideNav = setTimeout(() => {
          this.toggleSideNav();
        }, 5000);
      }
      // if (!this.sideNavOpened) {
      //   this.hideSideNav();
      // }

    }

    selectCEA() {
      const ceas = [...this._filter('')];
      console.log('🚀 ~ AppComponent ~ selectCEA ~ ceas:', ceas);
      this.dialogsSvc.prompt(
        'Seleccionar CEA',
        'Seleccione un CEA sobre el que realizar las consultas',
        [
          {
            key: 'cea',
            label: 'CEA',
            type: 'text',
            value: this.selectedCEA,
            autocomplete: {
              options: ceas.map(v => {
                return {
                  label: v,
                  value: v
                };
              })
            }
          }
        ]
      ).subscribe((res: any) => {
        if (res) {
          this.onSelectCEA({
            source: {
              value: res.cea.value
            }
          });
          // this.selectedCEA = res.cea;
        }
      });
    }

    hideSideNav() {
      console.log("🚀 ~ AppComponent ~ hideSideNav ~ document.getElementById('cmmainmnu'):", document.getElementById('mainmnu'));
      // document.getElementById('mainmnu').style.width = '58px!important';
      // document.getElementById('mainmnu').style.maxWidth = '58px!important';

      document.getElementById('mainmnu').classList.add('closed');
      setTimeout(() => {
        document.getElementById('mainmnu').classList.remove('closed');
        // document.getElementById('mainmnu').style.width = '58px';
        // document.getElementById('mainmnu').style.maxWidth = '58px';
        // document.getElementById('mainmnu').style.maxWidth = 'unset';
      }, 1500);
    }

    panelClicked(ev) {
      // console.log(ev);
      if (ev.data && ev.data.action_str) {
        const action = ev.data.action_str.split(':');
        if (action[0] === 'openTransmission') {
          this.appService.openTransmission(ev);
        } else if (action[0] === 'openDoc') {
          this.appService.openDoc(ev);
        }
        this.server.delete(
          'users/notifications/' + ev.id
        ).subscribe((res: any) => {
          // console.log(res);
        });
      }
    }

    panelClosed(ev) {
      // console.log(ev);
      if (ev.id) {
        this.server.delete(
          'users/notifications/' + ev.id
        ).subscribe((res: any) => {
          // console.log(res);
        });
      }
    }

    newBugReport(): void {

      const classifications = this.bugsReortsSvc.classifications.map(v => {
        return {
          label: v.name,
          value: v.id
        };
      });
      const severities = this.bugsReortsSvc.severities.map(v => {
        return {
          label: v.name,
          value: v.id
        };
      });
      // console.log(classifications, severities);
      const form = [
        {
          key: 'subject',
          label: 'Título',
          type: 'text',
          value: '',
          fxFlex: '100%',
          validation: {
            required: true
          },
          validationMessages: {
            required: 'Escriba un título descriptivo del error'
          }
        },
        {
          key: 'description',
          label: 'Descripción',
          type: 'textarea',
          value: '',
          fxFlex: '100%',
          validation: {
            required: true
          },
          validationMessages: {
            required: 'Describa lo más detallada y claramente el  error'
          }
        },
        {
          key: 'platform',
          label: 'Sistema operativo',
          type: 'select',
          value: '',
          fxFlex: '50%',
          options: [
            {
              label: 'Windows',
              value: 'Windows'
            },
            {
              label: 'Mac OS',
              value: 'Mac OS'
            },
            {
              label: 'Linux',
              value: 'Linux'
            },
            {
              label: 'Android',
              value: 'Android'
            },
            {
              label: 'iOS',
              value: 'iOS'
            },
            {
              label: 'Chrome OS',
              value: 'Chrome OS'
            }
          ],
          validation: {
            required: true
          },
          validationMessages: {
            required: 'Seleccione su sistema operativo'
          }
        },
        {
          key: 'browser',
          label: 'Navegador',
          type: 'select',
          value: '',
          fxFlex: '50%',
          options: [
            {
              label: 'Google Chrome',
              value: 'Chrome'
            },
            {
              label: 'Mozilla Firefox',
              value: 'Firefox'
            },
            {
              label: 'Apple Safari',
              value: 'Safari'
            },
            {
              label: 'Opera',
              value: 'Opera'
            }
          ],
          validation: {
            required: true
          },
          validationMessages: {
            required: 'Seleccione el navegador'
          }
        },
        {
          key: 'classification',
          label: 'Tipo',
          type: 'select',
          value: '',
          fxFlex: '50%',
          options: classifications
        },
        {
          key: 'severity',
          label: 'Importancia',
          type: 'select',
          value: '',
          fxFlex: '50%',
          options: severities
        },
      ];
      this.dialogsSvc.prompt(
        'Informe de error',
        'Aquí puede informar de un error al equipo de desarrollo de SIRA-Ganaderos.' +
        'Intente escribir un título descriptivo del error y una descripción clara y detallada del mismo.',
        form,
        'Enviar',
        'Cancelar',
        null,
        {
          appearance: this.uiSvc ? this.uiSvc.appearance : 'outline'
        }
      ).subscribe((res: any) => {
        // console.log(res);
        if (res) {
          this.bugsReortsSvc.send(res)
            .pipe(
              takeUntil(this.unsubscribe)
            )
            .subscribe((response: any) => {
              if (response.result) {
                this.dialogsSvc.confirm(
                  'Informe enviado correctamente',
                  'Su informe de errores ha sido enviado correctamente. El equipo de SIRA-Ganaderos le mantendrá informado.',
                  'Cerrar'
                ).subscribe( _ => {});
              }
            });
        }
      });
    }

    userLogs() {
      this.router.navigate(['/users-logs']);
    }

    toggleDarkTheme(): void {

        const overlayContainerClasses = this.overlayContainer.getContainerElement().classList;
        overlayContainerClasses.remove(this.themeClass);
        if (this.themeClass === 'light') {
          this.appService.isDark = true;
          this.themeClass = 'twa-dark-theme';
          this.themeButtonText = 'Light theme';
        } else {
          this.appService.isDark = false;
          this.themeClass = 'light';
          this.themeButtonText = 'Dark Theme';
        }
        this.appService.themeChanges.next(this.appService.isDark);
        overlayContainerClasses.add(this.themeClass);
        localStorage.setItem('themeClass', this.themeClass);

    }

    setTheme(newTheme: string): void {

        const overlayContainerClasses = this.overlayContainer.getContainerElement().classList;
        overlayContainerClasses.remove(this.themeClass);
        this.themeClass = newTheme;
        if (this.themeClass === 'twa-dark-theme') {
          this.appService.isDark = true;
          this.themeButtonText = 'Light theme';
        } else {
          this.appService.isDark = false;
          this.themeButtonText = 'Dark Theme';
        }
        this.appService.themeChanges.next(this.appService.isDark);
        localStorage.setItem('themeClass', this.themeClass);
        overlayContainerClasses.add(this.themeClass);

    }

    showDashboardSettings() {
        let ret = false;

        if (
            this.router.url === '/dashboard' ||
            this.router.url === '/main' ||
            this.router.url === '/' ||
            this.router.url.substr(0, 5) === '/cea/'
           ) {
          ret = true;
        }

        return ret;
    }

    editDashboard() {
        this.appService.dashboardEditing = !this.appService.dashboardEditing;
    }

    onSelectCEA(event): void {

        this.selectedCEA = event.source.value;
        this.selectedCEAObj = this.ceasWithNames.filter((val: any) => val.cea === this.selectedCEA)[0];
        this.setCEA();

    }

    setCEA(): void {

        localStorage.setItem('selectedCEA', this.selectedCEA);
        // console.log('Event: ' + this.selectedCEA);
        this.appService.setCEA(this.selectedCEA);
        this.animalsData.setCEA(this.selectedCEA);
        this.dashboardData.setCEA(this.selectedCEA);
        this.worksData.setCEA(this.selectedCEA);
        this.booksData.setCEA(this.selectedCEA);
        this.ceaSvc.setCEA(this.selectedCEA);
        this.criasSvc.setCEA(this.selectedCEA);
        this.pendingSvc.setCEA(this.selectedCEA);

      }

      clearSelectedCEA(): void {

        localStorage.setItem('selectedCEA', '');
        this.selectedCEA = '';
        this.ceaControl.setValue(this.selectedCEA);
        this.appService.setCEA('');
        this.animalsData.setCEA('');
        this.dashboardData.setCEA('');
        this.worksData.setCEA('');
        this.booksData.setCEA('');
        this.ceaSvc.setCEA('');
        this.criasSvc.setCEA('');
        this.pendingSvc.setCEA('');
        this.selectedCEAObj = {};

    }

    login(): void {

        this.server.post(
        'l',
        {
            user: '',
            password: ''
        }
        ).subscribe((response: any) => {
          this.response = response;
          if (response.result) {
              this.logged = response.logged;
              this.sssn = response.sssn;
          }
          // console.log(this.response);
        });

    }

    logout(): void {
        this.user = false;
        if (this.accountSvc) {
            this.accountSvc.data = undefined;
            this.accountSvc.aiEnabled = false;
        }
        localStorage.removeItem('api_key');
        this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
    }

    @Input('logged')
    set updateLogged(logged) {
        // console.log(logged);
    }

}
